import React, { useCallback, useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { companyInfo } from '../mock';
import MobileMenu from './MobileMenu';

const NAV = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Stones', href: '#stones' },
  { label: 'Catalogue', href: '/catalogue', route: true },
  { label: 'Projects', href: '#projects' },
  { label: 'Clients', href: '#clients' },
  { label: 'Contact', href: '#contact' },
];

const NavItem = ({ item, className }) => {
  const location = useLocation();
  const onHome = location.pathname === '/';
  const isActive = item.route && location.pathname === item.href;
  const activeClass = isActive ? '!text-[#7B1E24] font-semibold' : '';

  if (item.route) {
    return (
      <Link to={item.href} className={`${className} ${activeClass}`}>
        {item.label}
      </Link>
    );
  }
  const href = onHome ? item.href : `/${item.href}`;
  return (
    <a href={href} className={className}>
      {item.label}
    </a>
  );
};

const Navbar = () => {
  const location = useLocation();
  const onHome = location.pathname === '/';
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = useCallback(() => setOpen(false), []);

  // On non-home pages, always render solid backdrop (no dark hero behind it).
  const solid = scrolled || !onHome;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solid
          ? 'bg-[#FAF7F2]/95 backdrop-blur-md border-b border-[#E5DED0] py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between gap-6">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group flex-shrink-0">
          <img
            src={companyInfo.logoUrl}
            alt="Cherry Stone"
            className="w-10 h-11 object-contain group-hover:scale-105 transition-transform"
          />
          <div className="leading-tight">
            <div className="font-serif text-lg md:text-xl tracking-wide text-[#1a1a1a]">
              CHERRY STONE
            </div>
          </div>
        </Link>

        {/* Right cluster: nav + quote */}
        <div className="hidden lg:flex items-center gap-6 flex-shrink-0">
          <nav className="flex items-center gap-5 xl:gap-7">
            {NAV.map((n) => (
              <NavItem
                key={n.href}
                item={n}
                className="nav-link text-[12px] tracking-[0.16em] uppercase text-[#1a1a1a]/80 hover:text-[#7B1E24] whitespace-nowrap"
              />
            ))}
          </nav>
          <NavItem
            item={{ label: 'Get a Quote', href: '#contact' }}
            className="btn-cherry px-4 py-2.5 rounded-full text-[11.5px] tracking-[0.18em] uppercase font-medium whitespace-nowrap"
          />
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-[#1a1a1a]"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <MobileMenu items={NAV} open={open} onNavigate={closeMenu} />
    </header>
  );
};

export default Navbar;
